export interface FaqItem {
  q: string;
  a: string;
}

export const homeFaqs: FaqItem[] = [
  {
    q: "京都府外の対応も可能ですか？",
    a: "基本の対応エリアは京都府全域ですが、大阪府・滋賀県の隣接エリアはご相談に応じます。まずはお問い合わせください。",
  },
  {
    q: "即日対応は本当に可能ですか？",
    a: "スケジュールに空きがあれば、京都府内なら最短当日中にお伺い可能です。特に平日午前中のご連絡ですと当日対応の可能性が高くなります。",
  },
  {
    q: "見積りは無料ですか？",
    a: "はい、現地見積り・写真見積り（LINE可）ともに完全無料です。ご成約されなくてもキャンセル料は一切かかりません。",
  },
  {
    q: "遺品整理の際、貴重品や思い出の品はどうなりますか？",
    a: "作業前に必ずご要望をヒアリングし、貴重品・思い出の品は別途仕分けしてお渡しします。ご遺族様が遠方の場合はLINEやお電話で逐次確認可能です。",
  },
  {
    q: "料金は追加請求されませんか？",
    a: "お見積り後の追加請求は一切ありません。もし当日想定外の追加品目が発生した場合も、必ず事前にご確認いただいた上でご了承いただければ承ります。",
  },
  {
    q: "支払い方法は何がありますか？",
    a: "現金・銀行振込に対応しています。法人・不動産会社様には請求書払い（月末締翌月末払い）も対応しております。",
  },
  {
    q: "ゴミ屋敷清掃でも近隣に知られたくないのですが…",
    a: "無地の作業車両・私服対応・搬出時の目隠し養生など、プライバシーに最大限配慮した作業が可能です。ご予約時にお気軽にお申し付けください。",
  },
  {
    q: "産業廃棄物のマニフェストは発行してもらえますか？",
    a: "はい、京都府認可の産廃許可のもと、電子マニフェスト・紙マニフェストどちらも発行可能です。法人様案件では標準対応となります。",
  },
];

export const fuyouhinFaqs: FaqItem[] = [
  {
    q: "不用品回収の料金相場はどのくらいですか？",
    a: "不用品の量や搬出状況によって異なりますが、かご台車1台9,000円〜、軽トラック積み放題20,000円〜が目安です。まずはLINEで写真をお送りいただければ、概算のお見積りを無料で提示します。",
  },
  {
    q: "回収できないものはありますか？",
    a: "家電リサイクル法対象品（冷蔵庫・洗濯機・テレビ・エアコン）はリサイクル料金が別途必要です。また、危険物・引火性のあるものなどは回収できない場合があります。詳しくはお問い合わせください。",
  },
  {
    q: "即日対応や時間指定はできますか？",
    a: "最短即日での対応が可能です。作業時間帯のご希望もできる限り調整いたしますので、お気軽にご相談ください。",
  },
  {
    q: "立ち会いなしでも回収してもらえますか？",
    a: "可能です。事前にお見積りを確定いただいたうえで、鍵のお預かりや立会いなしでの回収にも対応しています。",
  },
  {
    q: "家電リサイクル対象品も回収してもらえますか？",
    a: "はい、回収可能です。家電リサイクル法に基づくリサイクル料金を別途申し受け、適正に処分いたします。",
  },
  {
    q: "引越しの一括回収はできますか？",
    a: "はい、引越しに伴う大量の不用品・粗大ゴミの一括回収に対応しています。お部屋まるごとの片付けもお任せください。",
  },
  {
    q: "支払い方法は何がありますか？",
    a: "現金・銀行振込に対応しています。法人・不動産会社様には請求書払い（月末締翌月末払い）も対応しております。",
  },
  {
    q: "キャンセル料はかかりますか？",
    a: "いいえ、お見積り後にご成約されなくても、キャンセル料は一切かかりません。お見積り・ご相談は完全無料ですので、お気軽にお問い合わせください。",
  },
  {
    q: "作業の所要時間の目安はどのくらいですか？",
    a: "回収品目や搬出状況により異なりますが、かご台車1台程度であれば30分〜1時間、軽トラック積み放題で1〜2時間、2トントラック以上の大量回収では2〜4時間程度を目安にしています。事前にお見積り時に目安をお伝えします。",
  },
];

export const ihinFaqs: FaqItem[] = [
  {
    q: "遺品整理の料金相場はどのくらいですか？",
    a: "遺品の量や部屋の広さによって異なりますが、1R〜1Kで20,000円〜、1LDK〜2LDKで35,000円〜、一軒家の丸ごと整理で50,000円〜が目安です。まずはLINEでお写真をお送りいただければ、概算のお見積りを無料で提示します。",
  },
  {
    q: "遺品整理の際、貴重品や思い出の品はどう扱われますか？",
    a: "作業前に必ずご要望をヒアリングし、貴重品・通帳・印鑑・書類・思い出の品は別途仕分けして必ずお渡しします。形見分けを希望される場合は、ご家族様に確認しながら丁寧に分類いたします。",
  },
  {
    q: "遠方に住んでいて立ち会えませんが、依頼できますか？",
    a: "はい、可能です。鍵のお預かりに対応しており、作業の進捗や貴重品の発見状況はLINEやお電話で写真付きで逐次ご報告いたします。遠方のご遺族様のご依頼も多数承っております。",
  },
  {
    q: "遺品の供養はしてもらえますか？",
    a: "はい、対応しております。仏壇・位牌・お線香・掛け軸などの宗教的な品々は、提携する寺院で合同供養を承ることが可能です。供養を希望されない品についても、丁寧に分別して処分いたします。",
  },
  {
    q: "相続手続きに必要な書類の仕分けもできますか？",
    a: "はい、通帳・保険証券・権利書・契約書類など、相続手続きに必要な重要書類は専用の分類ケースに仕分けてお渡しいたします。専門家（司法書士等）のご紹介も可能です。",
  },
  {
    q: "作業の立ち会いは必要ですか？",
    a: "原則として立ち会いをお願いしておりますが、ご事情がある場合は立ち会いなしでも対応可能です。その際は作業前後の写真報告や逐次のご連絡で、安心して進めていただける体制を整えております。",
  },
  {
    q: "作業の所要時間の目安はどのくらいですか？",
    a: "1R〜1Kのお部屋で半日〜1日、1LDK〜2LDKで1〜2日、一軒家の丸ごと整理では2〜3日程度が目安です。事前のお見積り時に、物件の広さや遺品量に応じたスケジュールをご案内いたします。",
  },
  {
    q: "支払い方法は何がありますか？",
    a: "現金・銀行振込に対応しています。また、相続手続きの関係で請求書払いをご希望の場合は、月末締め翌月末払いにも対応しております。",
  },
  {
    q: "見積りは無料ですか？",
    a: "はい、現地見積り・写真見積り（LINE可）ともに完全無料です。お見積り後にご成約されなくてもキャンセル料は一切かかりません。",
  },
];

export const gomiYashikiFaqs: FaqItem[] = [
  {
    q: "ゴミ屋敷清掃の料金相場はどのくらいですか？",
    a: "堆積ゴミの量や部屋の状況によって大きく異なりますが、1R〜1Kで50,000円〜、1LDK〜2LDKで100,000円〜、一軒家の場合は150,000円〜が目安です。まずはLINEでお写真をお送りいただければ、概算のお見積りを無料で提示します。",
  },
  {
    q: "近隣に知られたくないのですが、配慮してもらえますか？",
    a: "無地の作業車両・目立たない服装・搬出時の目隠し養生など、プライバシーと近隣への配慮を徹底した作業が可能です。「引越し」「不用品回収」を装った作業にも対応いたしますので、ご予約時にお申し付けください。",
  },
  {
    q: "害虫や悪臭の対策はしてもらえますか？",
    a: "はい、対応しております。ゴミの搬出後に、消臭・除菌・害虫駆除のオプション作業を承ります。必要に応じて専門業者と連携し、原状回復レベルの清掃まで対応いたします。",
  },
  {
    q: "本人の同意がないと依頼できませんか？",
    a: "原則としてお住まいの方の同意が必要です。ただし、ご家族や親族がご本人と同居していない場合でも、ご本人の同意を得た上での作業は可能です。まずはお電話またはLINEでご相談ください。",
  },
  {
    q: "分別やリサイクルはしてもらえますか？",
    a: "はい、可能な限り分別を行い、リサイクル可能なものは積極的に再資源化いたします。家電リサイクル法対象品は適正に処分いたします。",
  },
  {
    q: "作業中は立ち会いが必要ですか？",
    a: "原則として立ち会いをお願いしておりますが、ご事情がある場合は鍵のお預かりで立ち会いなしでも対応可能です。作業の進捗は写真付きで逐次ご報告いたします。",
  },
  {
    q: "作業の所要時間の目安はどのくらいですか？",
    a: "1R〜1Kで1〜2日、1LDK〜2LDKで2〜3日、一軒家の場合は3〜5日程度が目安です。堆積ゴミの量や部屋数によって変動しますので、事前のお見積り時にスケジュールをご案内いたします。",
  },
  {
    q: "支払い方法は何がありますか？",
    a: "現金・銀行振込に対応しています。分割払いのご相談も承りますので、お気軽にお問い合わせください。",
  },
  {
    q: "見積りは無料ですか？",
    a: "はい、現地見積り・写真見積り（LINE可）ともに完全無料です。お見積り後にご成約されなくてもキャンセル料は一切かかりません。",
  },
];